module.exports = __webpack_public_path__ + "img/11.0f6f2583.png";